/* import "../../static/css/login.css"; */
import {type FormEvent, useCallback, useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Loading from "../Loading.tsx";
import {frontBaseUrl, frontEndType} from "../../build_constants.ts";
import {useTranslation} from 'react-i18next';
import {membership, UserAPIConnectorError} from "../../lib/Membership.ts";
import {swal_util} from "../../lib/SwalUtil.ts";
import {BlueshiftAPIConnectorUnknownError} from "../../lib/api.ts";
import {Navbar} from "../../components/Navbar.tsx";
import SignUpAndFindAccountBlock from "./SignUpAndFindAccountBlock.tsx";
import StandAloneLogo from "./StandAloneLogo.tsx";
import AuthContext from "../../components/AuthContext.ts";
import {FRONT_END_TYPE} from "../../constants.ts";


interface ContentProps {
    toggleSidebar?: () => void,
    loginAfterPage: string,
    reloadRequire: boolean
}


const Login = ({toggleSidebar, loginAfterPage, reloadRequire}: ContentProps) => {
    const {t} = useTranslation('ui');

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const authContext = useContext(AuthContext);
    const isAuthenticated = authContext?.isAuthenticated ?? false;

    useEffect(() => {
        if (isAuthenticated) {
            const navigateState = {from: {pathname: location.pathname, search: location.search, hash: location.hash}};
            navigate(loginAfterPage, {replace: true, state: navigateState});
        }

        return () => {
        }
    }, [loginAfterPage, isAuthenticated, navigate]);

    const onSubmitLoginForm = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const frmData = new FormData(e.currentTarget);
        const username = frmData.get("username") as string;
        const password = frmData.get("password") as string;

        setLoading(true);
        try {
            await membership.signIn(username, password);
            authContext?.invalidate();


            if(reloadRequire) {
                location.href = `${frontBaseUrl}/dashboard`;
            } else {
                navigate(`${frontBaseUrl}/dashboard`);
            }
        } catch (err) {
            if (err instanceof UserAPIConnectorError) {
                await swal_util.show_warning(err.localization);
            } else if (err instanceof BlueshiftAPIConnectorUnknownError) {
                await swal_util.show_warning(err.message);
            } else {
                console.error(err);
            }
        }
        setLoading(false);
        return false;
    }, [authContext, navigate, reloadRequire]);


    const isXslabFront = frontEndType == FRONT_END_TYPE.XSLAB;
    const className = isXslabFront ? "container-wide" : "d-block vh-100";

    return (
        <>
            {loading && <Loading text={t("login.tryingToLogIn")}/>}
            {
                <main id="login" className={className}>
                    <Navbar toggleSidebar={toggleSidebar}/>

                    <article className="" id="wrapper">
                        <div className="content section core-value row row-heading justify-content-between">
                            {!isXslabFront && <StandAloneLogo/>}

                            <div className="col-sm-auto col-heading col-12 col-md-6">
                                <div className="section-heading text-sm-left is-visible">
                                    <h4 id="">{t("login.welcomeBack")}</h4>
                                    <h2 className=""> {t("login.login")}</h2>
                                </div>
                            </div>
                            <div className="form-box col-12 col-md-6">
                                <form className="custom-validation" id="form_login" action="#"
                                      onSubmit={onSubmitLoginForm}>
                                    <div className="mt-4">
                                        <input type="text"
                                               name="username"
                                               className="form-control rounded-pill px-4"
                                               placeholder={t("login.usernamePlaceholder")} autoComplete="username"/>
                                    </div>

                                    <div className="mt-3">
                                        <input type="password"
                                               name="password"
                                               className="form-control rounded-pill px-4"
                                               placeholder={t("login.passwordPlaceholder")}
                                               autoComplete="current-password"
                                               autoCapitalize="off"/>
                                    </div>

                                    <div className="mt-3 d-grid">
                                        <button className="button_blue" type="submit">{t("login.signIn")}</button>
                                    </div>

                                    <SignUpAndFindAccountBlock/>
                                </form>
                            </div>
                        </div>

                    </article>

                </main>
            }
        </>
    );
}

export default Login;
